import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "warning-container" }
const _hoisted_2 = { class: "warning-wrapper" }
const _hoisted_3 = { class: "icon-wrapper" }
const _hoisted_4 = { class: "warning-text" }
const _hoisted_5 = { class: "alert-title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "cta-wrapper" }


export default /*@__PURE__*/_defineComponent({
  __name: 'WarningBanner',
  props: {
    title: {},
    description: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "32px",
          class: "alert-icon",
          color: "#FF2424"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("mdi-bell-alert-outline")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.title), 1),
        _createElementVNode("p", { innerHTML: _ctx.description }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "action")
      ])
    ])
  ]))
}
}

})